export var BillingTestId;
(function (BillingTestId) {
    BillingTestId["Content"] = "BillingContent";
    BillingTestId["TeamAccountPayment"] = "BillingTeamAccountPayment";
    BillingTestId["ChangePayment"] = "BillingChangePayment";
    BillingTestId["SelfServeDisabledCopy"] = "SelfServeDisabledCopy";
})(BillingTestId || (BillingTestId = {}));
